import './App.css';
import './Header'
import Header from './Header';
import QuizCompo from './QuizCompo';

function App() {
  return (
    <div className="App">      
    <Header/>
    <QuizCompo/>
    </div>
  );
}

export default App;
